export default "__VITE_ASSET__fd45b569__"